// Displays play time. The value comes from useLiveBill, so the clock and the
// bill share one source and can never disagree — and both freeze on pause.
export function formatPlayClock(ms) {
  const diff = Math.max(0, ms || 0);
  const hours = Math.floor(diff / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export default function LiveTimer({ playedMs, paused = false }) {
  return (
    <div className="play-clock-box">
      <span
        className={`play-clock font-mono-timer text-4xl md:text-5xl font-bold tracking-wider transition-opacity duration-300 ${
          paused ? "text-amber-400/80" : ""
        }`}
        data-testid="live-timer"
      >
        {formatPlayClock(playedMs)}
      </span>
    </div>
  );
}
